import { useState } from 'react'
import { CategoryIds } from '../../CategoryTabs'
import { MappedProgressData } from '../types'

export const useProgressTrackerTab = (
  categoryId: CategoryIds,
  progressData?: MappedProgressData,
) => {
  const data = progressData?.[categoryId] || []
  const [activeServiceId, setActiveServiceId] = useState(data?.[0]?.id)
  const selectedService = data.find(service => service.id === activeServiceId)

  return {
    data,
    activeServiceId,
    setActiveServiceId,
    selectedService: selectedService || data[0],
  }
}

export default useProgressTrackerTab
